import { useContext, useEffect, useState } from "react"
import "./css/Home.css"
import { SpinnerCircular } from "spinners-react"
import { DashboardState } from "./Dashboard"
import Forms from "./Forms"
import decode from "jwt-decode"
import Leads from "./Leads"
import { Navigate } from "react-router-dom"

const Home = () => {
    const [redirect, setRedirect] = useState(false)

    const { state, actions } = useContext(DashboardState)

    const _crm__token = localStorage.getItem("_crm__token")

    let userdata

    if (_crm__token) {
        userdata = decode(_crm__token)
    }

    useEffect(() => {
        let timeout

        const domain = window.location.host
        const protocol = window.location.protocol

        if (redirect) {
            timeout = setTimeout(() => {
                window.location.href = `${protocol}//${domain}`
            }, 5000)
        }

        return () => clearTimeout(timeout)
    }, [redirect])

    // Admin and lead managers can only access the page
    // if (userdata && userdata.role === undefined) {
    //     if (redirect === false) {
    //         setRedirect(true)
    //     }

    //     return (
    //         <div className="_2olg">
    //             <div className="thread-ewer">
    //                 <span>You are not authorized</span>
    //                 <span className="impasted-toes">Redirecting to homepage...</span>
    //             </div>
    //         </div>
    //     )
    // }

    const isAdmin = userdata && userdata.role && userdata.role.includes("admin")

    return (
        <div className="_3xqh">
            {state.outletLoading ? (
                <div className="syrupier-yay">
                    <SpinnerCircular />
                </div>
            ) : (
                isAdmin ? <Navigate to="/forms" /> : <Navigate to="/Category" />
            )}
        </div>
    )
}

export default Home
